import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination, Virtual } from "swiper";
import { textLengthFiltered, shuffleData } from "../utils/common";
import { OtaData } from "../data/ota.js";

const Ota = () => {
    const screenWidth = useRef(window.innerWidth).current;
    const swiperOptions = {
        slidesPerView: screenWidth > 767 ? 4 : 1.9,
        slidesPerGroup: screenWidth > 767 ? 4 : 1,
        spaceBetween: screenWidth > 767 ? 28 : 16,
        navigation: screenWidth > 767 ? true : false,
        centeredSlides: screenWidth > 767 ? false : true,
        pagination: screenWidth > 767 ? { clickable: true } : false,
        loop: screenWidth > 767 ? false : true
    };

    const kkdayData = OtaData.filter((item) => {
        return item.type === "kkday";
    });
    const coolData = OtaData.filter((item) => {
        return item.type === "cool";
    });
    const readygoData = OtaData.filter((item) => {
        return item.type === "readygo";
    });
    const budgetData = OtaData.filter((item) => {
        return item.type === "budget";
    });

    const shuffleKkdayData = shuffleData(kkdayData);
    const shuffleCoolData = shuffleData(coolData);
    const shuffleReadygoData = shuffleData(readygoData);
    const shuffleBudgetData = shuffleData(budgetData);

    let result = [];

    for (let i = 0; i < 16; i++) {
        result[i * 4] = shuffleKkdayData[i];

        let randomCool = Math.floor(Math.random() * coolData.length);
        let randomReadygo = Math.floor(Math.random() * readygoData.length);
        let randomBudget = Math.floor(Math.random() * budgetData.length);

        if (i <= coolData.length - 1) {
            result[i * 4 + 1] = shuffleCoolData[i];
        } else {
            result[i * 4 + 1] = shuffleCoolData[randomCool];
        }

        if (i <= readygoData.length - 1) {
            result[i * 4 + 2] = shuffleReadygoData[i];
        } else {
            result[i * 4 + 2] = shuffleReadygoData[randomReadygo];
        }

        if (i <= budgetData.length - 1) {
            result[i * 4 + 3] = shuffleBudgetData[i];
        } else {
            result[i * 4 + 3] = shuffleBudgetData[randomBudget];
        }
    }

    return (
        <section
            id="ota"
            className="ota"
            data-aos="fade-in"
            data-aos-easing="linear"
            data-aos-duration="1000"
        >
            <h2 className="title">
                潮Way台南精選體驗
            </h2>
            <h3>
                潮Way台南為你精選多項熱門商品，<br />
                最潮住宿景點任你配，讓玩樂蹦出新滋味！<br />
                快出發去台南，打造你潮Way台南之旅。
            </h3>
            <div className="ota-slider container">
                <Swiper
                    modules={[Autoplay, Navigation, Pagination, Virtual]}
                    slidesPerView={swiperOptions.slidesPerView}
                    slidesPerGroup={swiperOptions.slidesPerGroup}
                    spaceBetween={swiperOptions.spaceBetween}
                    navigation={swiperOptions.navigation}
                    pagination={swiperOptions.pagination}
                    centeredSlides={swiperOptions.centeredSlides}
                    autoplay={{ delay: 5000 }}
                    loop={swiperOptions.loop}
                    virtual
                >
                    {
                        result && result.map((item, i) => (
                            <SwiperSlide key={item.title + i} virtualIndex={i + 1} className="item">
                                <a href={item.link || "#"} target="_blank" rel="noreferrer">
                                    <div className="ota-img">
                                        <img loading="lazy" src={item.image} alt={item.title} />
                                    </div>
                                    <div className="ota-content">
                                        <h3>{textLengthFiltered(item.title, 9)}</h3>
                                        <p>{textLengthFiltered(item.description, 13)}</p>
                                        <div className="ota-footer">
                                            <span>TWD
                                                <span className="ota-price">{item.price}</span>
                                            </span>
                                            <button>立即選購</button>
                                        </div>
                                    </div>
                                </a>
                            </SwiperSlide>
                        ))
                    }
                </Swiper>
            </div>
        </section>
    );
};

export default Ota;
